import {
  Box,
  Card,
  CardHeader,
  CardContent,
  Collapse,
  Grid,
  TextField,
  Typography,
  Autocomplete,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  Table,
  TableContainer,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  Backdrop,
  CircularProgress,
  Button,
  Alert,
  DialogTitle,
  Divider
} from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import RefreshIcon from '@mui/icons-material/Refresh';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import SearchIcon from '@mui/icons-material/Search';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import DescriptionIcon from '@mui/icons-material/Description';
import { makeStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DifferentModelSuggest from 'src/components/DifferentModelSuggest';
import DiffModelSuggestSolCenter from 'src/components/DiffModelSuggestSolCenter';
import ExchangeOfficeSubStatus from 'src/components/ExchangeOfficeSubStatus';
import SolutionCenterSubStatus from 'src/components/SolutionCenterSubStatus';
import {
  getChangeReasons,
  getChangeReasonWithUp
} from 'src/store/slices/commonSlice';
import { getMaterialCost } from 'src/store/slices/solutionCenterProcessSlice';
import { generalFollowActions } from 'src/store/slices/generalFollowSlice';
import SapRefundProcess from './SapRefundProcess';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import { getUser, getUserRole } from 'src/utils/Common';
import CloseIcon from '@mui/icons-material/CloseOutlined';
import SaveAsIcon from '@mui/icons-material/SaveAs';
import MaterialSearch from 'src/components/Selects/MaterialSearch';
import GroupIcon from '@mui/icons-material/Group';
import axios from 'src/utils/axios';
import { Height } from '@mui/icons-material';
import { getReceiptInfoChat } from 'src/store/slices/informationChatSlice';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';

const useStyles = makeStyles((theme) => ({
  cardscontent: {
    minHeight: 400,
    width: '100%'
  },
  backdrop: {
    zIndex: 1500,
    color: '#fff'
  },
  div: {
    fontWeight: 'bold',
    fontSize: '12px',
    width: '100%'
  },
  div2: {
    fontSize: '12px',
    width: '100%'
  },
  icerikBilgi: {
    margin: '0px',
    fontWeight: '600',
    fontSize: '12px',
    lineHeight: '1.43',
    letterSpacing: '0.01071em',
    color: 'black',
    marginBottom: '7.5px'
  },
  autocomplete: {
    fontSize: '10px'
  },
  button: {
    color: '#FF9800',
    backgroundColor: '#424242',
    '&:hover': {
      color: '#FF9800',
      backgroundColor: '#424242'
    }
  },
  mainCard: {
    border: '1px solid #e0e0e0',
    borderRadius: '16px',
    position: 'sticky',
    top: 210,
    zIndex: 7,
    backgroundColor: '#fff',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    marginBottom: '16px'
  },
  cardHeader: {
    backgroundColor: '#f5f5f5',
    color: '#424242',
    padding: '10px 16px',
    cursor: 'move',
    borderBottom: '1px solid #e0e0e0',
    '& .MuiCardHeader-title': {
      fontSize: '12px',
      fontWeight: '700',
      letterSpacing: '0.5px'
    }
  },
  '@keyframes spin': {
    '0%': {
      transform: 'rotate(0deg)'
    },
    '100%': {
      transform: 'rotate(360deg)'
    }
  },
  spinning: {
    animation: '$spin 1s linear infinite'
  },
  exchangeInfoLabel: {
    fontSize: '11px',
    color: '#757575',
    fontWeight: 600,
    marginBottom: '6px'
  },
  exchangeInfoValue: {
    fontSize: '13px',
    color: '#263238',
    fontWeight: 700,
    wordBreak: 'break-word',
    whiteSpace: 'pre-wrap'
  }
}));

function ExchangeInformation() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const userRole = getUserRole().Component;
  const Role = getUserRole().RoleId;
  const SessionUser = getUser();
  const invoiceData = useSelector(
    (state) => state.generalFollowSlice.invoiceDetail
  );
  const changeReasonData = useSelector(
    (state) => state.commonSlice.changeReasons
  );
  const upChangeData = useSelector(
    (state) => state.commonSlice.upChangeReasons
  );
  const exData = useSelector((state) => state.generalFollowSlice.exDatas);

  const [actionReasonSavePopUp, setActionReasonSavePopUp] = useState(false);
  const [outOfStock, setOutOfStock] = React.useState(
    invoiceData[0]?.Exchange?.NoneProduct
  );
  const [materialDsc, setMaterialDsc] = React.useState(
    invoiceData[0]?.Exchange?.MaterialDsc
  );
  const [outOfStockPrice, setOutOfStockPrice] = React.useState(
    invoiceData[0]?.UnsuppliedStokPrice
  );
  const [changeReasonList, setChangeReasonList] = React.useState(
    changeReasonData.filter(
      (i) => i.ChangeReason == invoiceData[0]?.Exchange?.ExchangeResonMain
    )[0]
  );
  const [upChangeReason, setUpChangeReasons] = React.useState(null);
  const [materialCostPopUp, setMaterialCostPopUp] = React.useState(false);
  const [materialCostData, setMaterialCostData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [exhanchangeEditNote, setExhanchangeEditNote] = React.useState('');
  const [collapsed, setCollapsed] = React.useState(false);
  const [refreshing, setRefreshing] = React.useState(false);
  const [productExchangePopUp, setProductExchangePopUp] =
    React.useState(false);
  const [productExchangeLoading, setProductExchangeLoading] =
    React.useState(false);
  const [productExchangeError, setProductExchangeError] = React.useState('');
  const [productExchangeData, setProductExchangeData] = React.useState(null);
  const receiptSHFNumbers = invoiceData[0].Apply.ReceiptSHFNumbers;
  const numbers = receiptSHFNumbers.split(',').map((num) => num.trim());
  const hasOutOfStock = Boolean(outOfStock?.toString().trim());
  const showAlert = !numbers.includes('3194') && !numbers.includes('571'); // testteki hali 3161 ama canlı için 3194

  // const [airConditionerReceiptNumber, setAirConditionerReceiptNumber] = React.useState(invoiceData[0]?.Exchange.AirconditionerReceiptNo );
  const [airConditionerReceiptNumber, setAirConditionerReceiptNumber] =
    React.useState(null);

  useEffect(() => {
    if (!invoiceData[0]?.Exchange?.ExchangeResonMain) {
      return;
    } else {
      dispatch(getChangeReasons()).then((a) => {
        dispatch(
          getChangeReasonWithUp(invoiceData[0]?.Exchange?.ExchangeResonMain)
        ).then((b) => {
          var temp = b.payload.filter(
            (i) => i?.DEGISIM_NEDENI == invoiceData[0]?.Exchange?.ExchangeReson
          )[0];
          setUpChangeReasons(temp);
        });
      });
    }
  }, [dispatch]);

  function AirConReceiptNo(val) {
    var tempData = JSON.parse(JSON.stringify(invoiceData));
    tempData[0].Exchange.AirconditionerReceiptNo = val;
    dispatch(generalFollowActions.updateNewData(tempData));
    setAirConditionerReceiptNumber(val);
  }

  function changeReason(val) {
    //Değişim nedeni
    if (val?.ChangeReason) {
      dispatch(getChangeReasonWithUp(val?.ChangeReason)).then((b) => {
        var tempData = JSON.parse(JSON.stringify(invoiceData));
        tempData[0].Exchange.ExchangeResonMain = val?.ChangeReason;
        tempData[0].Exchange.ExchangeReson = b?.payload[0].DEGISIM_NEDENI;
        tempData[0].Exchange.ExchangeReasonMainDsc = val?.Dsc;
        tempData[0].Exchange.ExchangeReasonSurveyCheck =
          b?.payload[0].ANKET_KONTROL;
        dispatch(generalFollowActions.updateNewData(tempData));
        setChangeReasonList(val);
        setUpChangeReasons(b?.payload[0]);
      });
    }
  }

  function changeUpReason(val) {
    //Değişim nedeni detay
    var tempData = JSON.parse(JSON.stringify(invoiceData));
    tempData[0].Exchange.ExchangeReson = val?.DEGISIM_NEDENI;
    tempData[0].Exchange.ExchangeReasonMainDsc = val?.ACIKLAMA;
    tempData[0].Exchange.ExchangeReasonSurveyCheck = val?.ANKET_KONTROL;
    dispatch(generalFollowActions.updateNewData(tempData));
    setUpChangeReasons(val);
  }

  const setChangeMaterial = (param) => {
    var tempData = JSON.parse(JSON.stringify(invoiceData));
    tempData[0].Exchange.NoneProduct = param?.MALZEME_STOK_NO;
    dispatch(generalFollowActions.updateNewData(tempData));
    setOutOfStock(param.MALZEME_STOK_NO);
    setMaterialDsc(param.ACIKLAMA);
    setOutOfStockPrice(param.FIYAT);
    var total =
      parseFloat(param.FIYAT) + parseFloat(exData[0].Exchange.RecomendedPrice);
    dispatch(generalFollowActions.updateRecomendedPrice(total));
  };

  function changeSupplicedStok(val) {
    //Kdvli fiyat
    var tempData = JSON.parse(JSON.stringify(invoiceData));
    tempData[0].UnsuppliedStokPrice = val;
    dispatch(generalFollowActions.updateNewData(tempData));
    setOutOfStockPrice(val);
  }

  function GetMaterialCost(receiptNo) {
    setLoading(true);
    dispatch(getMaterialCost(receiptNo)).then((response) => {
      if (response?.payload?.length > 0) {
        setMaterialCostPopUp(true);
        setMaterialCostData(response?.payload);
      }
      setLoading(false);
    });
  }

  function GetReceiptDetail() {
    dispatch(
      getReceiptInfoChat([
        invoiceData[0]?.Exchange?.ApplyNo,
        invoiceData[0]?.Exchange?.Service
      ])
    )
      .then((response) => { })
      .catch((err) => {
        return;
      });
  }

  function getProductExchangeStatusInfo(data) {
    if (!data) {
      return {
        status: 'unknown',
        color: '#605e5c',
        bgColor: '#f5f5f5',
        borderColor: '#e1dfdd',
        icon: <WarningAmberIcon />,
        title: 'Sonuç Bekleniyor',
        description: ''
      };
    }

    // Sonuc alanı servisten metin ("Değişime Uygundur" / "Değişime Uygun Değildir")
    // ya da sayısal (1 / 0) gelebiliyor; her iki biçim de destekleniyor.
    const rawResult =
      data.Sonuc === undefined || data.Sonuc === null
        ? ''
        : data.Sonuc.toString().trim();
    const resultText = rawResult.toLocaleLowerCase('tr-TR');
    const numericResult =
      rawResult !== '' && !Number.isNaN(Number(rawResult))
        ? Number(rawResult)
        : null;

    // RedNedeni bir red kararı değil, algoritmanın gerekçe alanıdır: servis
    // "Değişime Uygundur" (Sonuc = 1) dönerken de doldurabiliyor
    // (ör. "Temin Problemi", "Malzeme End Of Life. Muadil Temin Problemi").
    // Bu yüzden uygunluk kararı yalnızca Sonuc alanından üretilir.
    const isRejected =
      numericResult === 0 ||
      resultText.includes('uygun değil') ||
      resultText.includes('uygun degil');
    const isApproved =
      !isRejected && (numericResult === 1 || resultText.includes('uygun'));

    if (isRejected) {
      return {
        status: 'rejected',
        color: '#d13438',
        bgColor: '#fff1f0',
        borderColor: '#f3b7b9',
        icon: <CancelIcon />,
        title: 'Değişime Uygun Değil',
        description: ''
      };
    }

    if (isApproved) {
      return {
        status: 'approved',
        color: '#107c10',
        bgColor: '#f1faf1',
        borderColor: '#b7dfb8',
        icon: <CheckCircleIcon />,
        title: 'Değişime Uygun',
        description: ''
      };
    }

    return {
      status: 'unknown',
      color: '#f7630c',
      bgColor: '#fff7ed',
      borderColor: '#ffd6a7',
      icon: <WarningAmberIcon />,
      title: 'Kontrol Gerekli',
      description: ''
    };
  }

  function getProductExchangeDisplayValue(value, fallback = 'Bilgi Yok') {
    if (value === undefined || value === null || value === '') {
      return fallback;
    }

    const normalizedValue = value.toString().trim();

    if (normalizedValue === '-') {
      return fallback;
    }

    if (normalizedValue === '0') {
      return 'Yok';
    }

    return value;
  }

  function hasProductExchangeValue(value) {
    if (value === undefined || value === null) {
      return false;
    }

    const normalizedValue = value.toString().trim();

    return normalizedValue !== '' && normalizedValue !== '-';
  }

  function renderProductExchangeDetail(label, value) {
    return (
      <Box>
        <Typography
          sx={{
            fontSize: '12px',
            color: '#605e5c',
            fontWeight: 600,
            marginBottom: '4px'
          }}
        >
          {label}
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: '15px', sm: '16px' },
            color: '#242424',
            fontWeight: 700,
            lineHeight: 1.35,
            wordBreak: 'break-word',
            whiteSpace: 'pre-wrap'
          }}
        >
          {getProductExchangeDisplayValue(value)}
        </Typography>
      </Box>
    );
  }

  function renderProductExchangeSection(title, icon, children) {
    return (
      <Grid item xs={12} sm={6}>
        <Box
          sx={{
            height: '100%',
            borderRadius: '8px',
            padding: '14px',
            backgroundColor: '#f8f8f8',
            boxShadow: '0 1px 3px rgba(0,0,0,0.08)'
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              marginBottom: '14px'
            }}
          >
            <Box
              sx={{
                width: 28,
                height: 28,
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#0078d4',
                backgroundColor: '#eff6fc'
              }}
            >
              {icon}
            </Box>
            <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#323130' }}>
              {title}
            </Typography>
          </Box>
          <Box sx={{ display: 'grid', gap: '12px' }}>{children}</Box>
        </Box>
      </Grid>
    );
  }

  function renderProductExchangeStatusCard(statusInfo) {
    return (
      <Box
        sx={{
          borderRadius: '8px',
          padding: { xs: '16px', sm: '18px' },
          marginTop: '12px',
          backgroundColor: statusInfo.bgColor,
          border: `1px solid ${statusInfo.borderColor}`,
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
        }}
      >
        <Box
          sx={{
            width: 44,
            height: 44,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: statusInfo.color,
            backgroundColor: '#ffffff',
            flexShrink: 0,
            '& svg': { fontSize: '28px' }
          }}
        >
          {statusInfo.icon}
        </Box>
        <Box>
          <Typography sx={{ fontSize: '20px', fontWeight: 700, color: statusInfo.color }}>
            {statusInfo.title}
          </Typography>
          {statusInfo.description ? (
            <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#323130', mt: 0.5 }}>
              {statusInfo.description}
            </Typography>
          ) : null}
        </Box>
      </Box>
    );
  }

  function handleProductExchangeQuery() {
    if (!hasOutOfStock) {
      return;
    }

    // Adet parametresi gönderilmiyor: stok yeterliliği malzemenin paket sayısı
    // üzerinden hesaplanıyor ve bu değeri API kendisi üretiyor.
    const birimkodu = invoiceData[0]?.Exchange?.Service?.toString();
    const Malzemekodu = outOfStock?.toString();
    const fisno = invoiceData[0]?.Apply?.ReceiptNumber?.toString();
    const sicilno = SessionUser?.UserId?.toString();

    setProductExchangePopUp(true);
    setProductExchangeLoading(true);
    setProductExchangeError('');
    setProductExchangeData(null);

    axios
      .get(`GetProductExchangeInfo/${birimkodu}/${Malzemekodu}/${fisno}/${sicilno}`)
      .then((response) => {
        const responseData = Array.isArray(response?.data)
          ? response?.data[0]
          : response?.data;
        setProductExchangeData(responseData || null);
        setProductExchangeLoading(false);
      })
      .catch((err) => {
        setProductExchangeError(
          err?.response?.data?.message ||
          err?.response?.data?.Message ||
          'Ürün değişim algoritması sorgulanırken hata oluştu.'
        );
        setProductExchangeLoading(false);
      });
  }

  const handleRefresh = () => {
    setRefreshing(true);
    dispatch(getChangeReasons()).then(() => {
      dispatch(
        getChangeReasonWithUp(invoiceData[0]?.Exchange?.ExchangeResonMain)
      );
    });
    setTimeout(() => setRefreshing(false), 500);
  };

  const handleToggleCollapse = () => {
    setCollapsed(!collapsed);
  };

  function handleExchangeReasonSave() {
    console.log(invoiceData[0]);
    const data = {
      Status: invoiceData[0]?.Exchange?.Status,
      ExchangeReasonDetail: invoiceData[0]?.Exchange?.ExchangeReson,
      ApplicationNumber: invoiceData[0]?.Exchange?.ApplyNo?.toString(),
      ServiceNumber: invoiceData[0]?.Exchange?.Service.toString(),
      UserID: invoiceData[0]?.UserID,
      Note: `Değişim Nedeni: ${invoiceData[0]?.Exchange?.ExchangeReasonMainDsc} olarak değiştirilmiştir. Mesaj: ${exhanchangeEditNote}`
    };
    if (exhanchangeEditNote.length < 9) {
      return;
    }
    setLoading(true);
    axios
      .post('ExchanceReasonEditSave', data, {
        headers: { 'Content-Type': 'application/json' }
      })
      .then((response) => {
        GetReceiptDetail();
        setActionReasonSavePopUp(false);
        setLoading(false);
        return;
      })
      .catch((err) => {
        setLoading(false);
        return;
      });
  }

  return (
    <>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Grid container spacing={0.5}>
        {userRole?.filter((i) => i.COMPONENT_NAME == 'SapRefundProcess')
          .length > 0 ? (
          <Grid item xs={12}>
            <SapRefundProcess />
          </Grid>
        ) : null}
        <Grid item xs={12}>
          <Card className={classes.mainCard}>
            <CardHeader
              className={classes.cardHeader}
              avatar={<DragIndicatorIcon sx={{ color: '#FF9800' }} />}
              action={
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Tooltip title="Değişim Nedeni Değiştir">
                    <IconButton
                      onClick={() => setActionReasonSavePopUp(true)}
                      sx={{ color: '#FF9800' }}
                    >
                      <SaveAsIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title={collapsed ? 'Genişlet' : 'Daralt'}>
                    <IconButton
                      onClick={handleToggleCollapse}
                      sx={{ color: '#FF9800' }}
                    >
                      {collapsed ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                    </IconButton>
                  </Tooltip>
                </Box>
              }
              title="Değişim Bilgileri"
            />
            <Collapse in={!collapsed} timeout="auto" unmountOnExit>
              <CardContent sx={{ padding: '12px' }}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={12}>
                    <Autocomplete
                      id="combo-box-demo"
                      options={changeReasonData}
                      disabled={
                        ![1, 2, 6].includes(Role[0]?.ROLE_ID) ||
                          invoiceData[0].AronStatus === 5
                          ? true
                          : false
                      }
                      getOptionLabel={(i) => i.Dsc}
                      value={changeReasonList || null}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          InputProps={{
                            ...params.InputProps,
                            style: { fontSize: '12px' }
                          }}
                          InputLabelProps={{
                            style: { fontSize: '11px', color: '#757575' }
                          }}
                          size="small"
                          label="Değişim Nedeni"
                          sx={{
                            '& .MuiOutlinedInput-root': { borderRadius: '12px' }
                          }}
                        />
                      )}
                      renderOption={(props, option) => (
                        <li {...props}>
                          <Typography
                            variant="body2"
                            style={{ fontSize: '14px' }}
                          >
                            {option.Dsc}
                          </Typography>
                        </li>
                      )}
                      onChange={(event, val) => {
                        changeReason(val);
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <Autocomplete
                      id="combo-box-demo"
                      options={upChangeData}
                      getOptionLabel={(i) => i.ACIKLAMA}
                      disabled={
                        ![1, 2, 6].includes(Role[0]?.ROLE_ID) ||
                          invoiceData[0].AronStatus === 5
                          ? true
                          : false
                      }
                      value={upChangeReason || null}
                      size="small"
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          InputProps={{
                            ...params.InputProps,
                            style: { fontSize: '12px' }
                          }}
                          InputLabelProps={{
                            style: { fontSize: '11px', color: '#757575' }
                          }}
                          label="Detay"
                          size="small"
                          sx={{
                            '& .MuiOutlinedInput-root': { borderRadius: '12px' }
                          }}
                        />
                      )}
                      renderOption={(props, option) => (
                        <li {...props}>
                          <Typography
                            variant="body2"
                            style={{ fontSize: '14px' }}
                          >
                            {option.ACIKLAMA}
                          </Typography>
                        </li>
                      )}
                      onChange={(event, val) => {
                        changeUpReason(val);
                      }}
                    />
                  </Grid>
                  {userRole?.filter(
                    (i) => i.COMPONENT_NAME == 'SolutionCenterSubStatus'
                  ).length > 0 ? (
                    <SolutionCenterSubStatus />
                  ) : null}
                  {userRole?.filter(
                    (i) => i.COMPONENT_NAME == 'ExchangeOfficeSubStatus'
                  ).length > 0 ? (
                    <ExchangeOfficeSubStatus />
                  ) : null}
                  <Grid item xs={12} md={12}>
                    <TextField
                      id="input-with-icon-textfield"
                      label="Servis Notu"
                      size="small"
                      className={classes.div}
                      inputProps={{
                        style: { fontSize: 11, fontWeight: 'bold' }
                      }}
                      InputLabelProps={{
                        style: { fontSize: '11px', color: '#757575' }
                      }}
                      value={
                        invoiceData[0]?.Exchange?.ServiceNote
                          ? invoiceData[0]?.Exchange?.ServiceNote
                          : '-'
                      }
                      fullWidth
                      variant="outlined"
                      multiline
                      minRows={1}
                      maxRows={3}
                      sx={{
                        '& .MuiOutlinedInput-root': { borderRadius: '12px' }
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <MaterialSearch
                      setMalzeme={setChangeMaterial}
                      setProduct={invoiceData[0]?.Model?.ProductId}
                      value={
                        {
                          MALZEME_STOK_NO: outOfStock,
                          ACIKLAMA: materialDsc
                        } || ''
                      }
                      searchParam=""
                    />
                  </Grid>
                  <Grid item xs={6} md={4}>
                    <TextField
                      id="input-with-icon-textfield"
                      label="KDV'li Fiyat"
                      size="small"
                      fullWidth
                      type="number"
                      variant="outlined"
                      value={outOfStockPrice}
                      disabled
                      inputProps={{
                        style: { fontSize: '12px' }
                      }}
                      InputLabelProps={{
                        style: { fontSize: '11px', color: '#757575' }
                      }}
                      sx={{
                        '& .MuiOutlinedInput-root': { borderRadius: '12px' }
                      }}
                      onChange={(event) => {
                        changeSupplicedStok(event.target.value);
                      }}
                    />
                  </Grid>

                  {/* <Grid item xs={2} md={2}></Grid> */}
                  <Grid item xs={6} md={4}>
                    <Tooltip title="Teminsiz Stok Fiş Detayı">
                      <Button
                        sx={{
                          borderRadius: '12px',
                          height: '35px',
                          fontSize: '10px',
                          padding: '8.5px 14px',
                          lineHeight: 1.5
                        }}
                        size="small"
                        fullWidth
                        className={classes.button}
                        onClick={() => {
                          GetMaterialCost(invoiceData[0]?.Apply?.ReceiptNumber);
                        }}
                      >
                        Detay
                        <CreditScoreIcon sx={{ ml: 1, fontSize: '14px' }} />
                      </Button>
                    </Tooltip>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <span>
                      <Tooltip title={!hasOutOfStock ? 'Teminsiz Stok seçilmedi' : 'Ürün değişim algoritmasını sorgula'}>
                        <Button
                          sx={{
                            borderRadius: '12px',
                            height: '35px',
                            fontSize: '10px',
                            padding: '8.5px 14px',
                            lineHeight: 1.5,
                            '&.Mui-disabled': {
                              color: '#FF9800'
                            },
                            '&.Mui-disabled svg': {
                              color: '#FF9800'
                            }
                          }}
                          size="small"
                          fullWidth
                          className={classes.button}
                          disabled={!hasOutOfStock}
                          onClick={handleProductExchangeQuery}
                        >
                          Sorgula
                          <SearchIcon sx={{ ml: 1, fontSize: '14px' }} />
                        </Button>
                      </Tooltip>
                    </span>
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          sx={{ color: '#FF9800', padding: '9px' }}
                          checked={invoiceData[0]?.Exchange?.CustomerError}
                          disabled
                        />
                      }
                      label="Tüketici hatası mevcut"
                      sx={{
                        '& .MuiFormControlLabel-label': {
                          fontSize: '12px'
                        },
                        margin: '0px'
                      }}
                    />
                  </Grid>
                </Grid>
                {Role?.filter((i) => i.ROLE_ID == 3).length > 0 ||
                  Role?.filter((i) => i.ROLE_ID == 4).length > 0 ? null : (
                  <Grid container spacing={2}>
                    {' '}
                    <Grid item xs={12} md={12}>
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        component="div"
                        className={classes.icerikBilgi}
                      >
                        Değişim Türü:&nbsp;&nbsp;&nbsp;&nbsp;
                        <Typography
                          variant="body2"
                          color="textSecondary"
                          component="span"
                          className={classes.div2}
                        >
                          {invoiceData[0]?.ChangeTypeAron
                            ? invoiceData[0]?.ChangeTypeAron
                            : '-'}
                        </Typography>
                      </Typography>
                    </Grid>
                  </Grid>
                )}
              </CardContent>
            </Collapse>
          </Card>
        </Grid>
      </Grid>
      <Grid item xs={12} style={{ paddingTop: 5 }}>
        {userRole?.filter(
          (i) => i.COMPONENT_NAME == 'DiffModelSuggestSolCenter'
        ).length > 0 ? (
          <DiffModelSuggestSolCenter />
        ) : null}
        {userRole?.filter((i) => i.COMPONENT_NAME == 'DifferentModelSuggest')
          .length > 0 ? (
          <DifferentModelSuggest />
        ) : null}
      </Grid>

      <Dialog
        open={productExchangePopUp}
        aria-labelledby="product-exchange-dialog-title"
        maxWidth="md"
        fullWidth
        onClose={() => {
          setProductExchangePopUp(false);
        }}
        PaperProps={{
          sx: {
            borderRadius: '8px',
            overflow: 'hidden',
            maxWidth: '760px',
            maxHeight: '80vh',
            boxShadow: '0 24px 64px rgba(0,0,0,0.24)'
          }
        }}
      >
        <DialogTitle
          id="product-exchange-dialog-title"
          sx={{
            padding: '12px 18px 10px',
            backgroundColor: '#ffffff',
            borderBottom: '1px solid #f0f0f0'
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 2
            }}
          >
            <Box>
              <Typography
                sx={{ fontSize: '18px', fontWeight: 600, color: '#242424' }}
              >
                Ürün Değişim Sonucu
              </Typography>
            </Box>
            <IconButton
              sx={{
                color: '#605e5c',
                '&:hover': { backgroundColor: '#f3f2f1' }
              }}
              onClick={() => {
                setProductExchangePopUp(false);
              }}
              aria-label="close"
              size="small"
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent
          sx={{
            padding: '22px 22px 18px',
            backgroundColor: '#ffffff',
            overflowY: 'auto'
          }}
        >
          {productExchangeLoading ? (
            <Box
              sx={{
                minHeight: 220,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 2
              }}
            >
              <CircularProgress sx={{ color: '#FF9800' }} />
              <Typography sx={{ fontSize: '13px', color: '#757575' }}>
                Algoritma sorgulanıyor, lütfen bekleyiniz...
              </Typography>
            </Box>
          ) : productExchangeError ? (
            <Alert severity="error">{productExchangeError}</Alert>
          ) : !productExchangeData ? (
            <Alert severity="info">Kayıt bulunamadı.</Alert>
          ) : (
            (() => {
              const statusInfo = getProductExchangeStatusInfo(productExchangeData);

              return (
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    {renderProductExchangeStatusCard(statusInfo)}
                  </Grid>
                  {renderProductExchangeSection(
                    'Muadil Bilgileri',
                    <CompareArrowsIcon sx={{ fontSize: '18px' }} />,
                    <>
                      {renderProductExchangeDetail(
                        'Muadil Sonucu',
                        productExchangeData.Sonuc_Muadil
                      )}
                      {renderProductExchangeDetail(
                        'Muadil Malzeme Kodu',
                        productExchangeData.Muadil_MalzemeKodu
                      )}
                    </>
                  )}
                  {renderProductExchangeSection(
                    'Temin Bilgileri',
                    <LocalShippingIcon sx={{ fontSize: '18px' }} />,
                    <>
                      {renderProductExchangeDetail(
                        'Temin Tarihi Sonucu',
                        productExchangeData.Sonuc_TeminTarihi
                      )}
                      {renderProductExchangeDetail(
                        'Temin Tarihi',
                        productExchangeData.TeminTarihi
                      )}
                    </>
                  )}
                  {hasProductExchangeValue(productExchangeData.Aciklama) ? (
                    <Grid item xs={12}>
                      <Box
                        sx={{
                          borderRadius: '8px',
                          padding: '14px',
                          backgroundColor: '#f8f8f8',
                          boxShadow: '0 1px 3px rgba(0,0,0,0.08)'
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                            marginBottom: '10px'
                          }}
                        >
                          <Box
                            sx={{
                              width: 28,
                              height: 28,
                              borderRadius: '8px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              color: '#605e5c',
                              backgroundColor: '#f3f2f1'
                            }}
                          >
                            <DescriptionIcon sx={{ fontSize: '18px' }} />
                          </Box>
                          <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#323130' }}>
                            Açıklama
                          </Typography>
                        </Box>
                        <Typography
                          sx={{
                            fontSize: '15px',
                            fontWeight: 600,
                            color: '#242424',
                            lineHeight: 1.45,
                            whiteSpace: 'pre-wrap'
                          }}
                        >
                          {productExchangeData.Aciklama}
                        </Typography>
                      </Box>
                    </Grid>
                  ) : null}
                  {hasProductExchangeValue(productExchangeData.RedNedeni) ? (
                    <Grid item xs={12}>
                      <Alert
                        severity={statusInfo.status === 'rejected' ? 'error' : 'info'}
                        icon={<WarningAmberIcon />}
                        sx={{
                          borderRadius: '8px',
                          backgroundColor:
                            statusInfo.status === 'rejected' ? '#fff1f0' : '#f3f9fd',
                          color: '#442726',
                          '& .MuiAlert-icon': {
                            color:
                              statusInfo.status === 'rejected' ? '#d13438' : '#0078d4'
                          }
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: '13px',
                            fontWeight: 700,
                            color:
                              statusInfo.status === 'rejected' ? '#a4262c' : '#005a9e'
                          }}
                        >
                          {statusInfo.status === 'rejected'
                            ? 'Red Nedeni'
                            : 'Algoritma Gerekçesi'}
                        </Typography>
                        <Typography sx={{ fontSize: '13px', fontWeight: 500, whiteSpace: 'pre-wrap', mt: 0.5 }}>
                          {getProductExchangeDisplayValue(productExchangeData.RedNedeni)}
                        </Typography>
                      </Alert>
                    </Grid>
                  ) : null}
                </Grid>
              );
            })()
          )}
        </DialogContent>
        <Divider />
        <DialogActions sx={{ padding: '12px 22px 18px', backgroundColor: '#ffffff' }}>
          <Button
            variant="outlined"
            size="small"
            onClick={() => {
              setProductExchangePopUp(false);
            }}
            sx={{
              color: '#323130',
              borderColor: '#d2d0ce',
              backgroundColor: '#ffffff',
              borderRadius: '8px',
              fontWeight: 600,
              textTransform: 'none',
              padding: '6px 18px',
              '&:hover': {
                borderColor: '#c8c6c4',
                backgroundColor: '#f3f2f1'
              }
            }}
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={materialCostPopUp}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="lg"
        fullWidth
      >
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <TableContainer sx={{ maxHeight: 440 }}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">Tip</TableCell>
                      <TableCell align="left">Kod</TableCell>
                      <TableCell align="center">Açıklama</TableCell>
                      <TableCell align="left">Miktar</TableCell>
                      <TableCell align="center">Fiyat</TableCell>
                      <TableCell align="center">Toplam Fiyat</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {materialCostData?.map((row) => (
                      <TableRow
                        key={row.KOD}
                        sx={{
                          '&:last-child td, &:last-child th': { border: 0 }
                        }}
                      >
                        <TableCell align="center">
                          {row.TIP ? row.TIP : '-'}
                        </TableCell>
                        <TableCell align="left">
                          {row.KOD ? row.KOD : '-'}
                        </TableCell>
                        <TableCell align="center">
                          {row.ACIKLAMA ? row.ACIKLAMA : '-'}
                        </TableCell>
                        <TableCell align="left">
                          {row.MIKTAR ? row.MIKTAR : '-'}
                        </TableCell>
                        <TableCell align="center">
                          {row.FIYAT ? row.FIYAT : '-'}
                        </TableCell>
                        <TableCell align="center">
                          {row.TOPLAM_FIYAT ? row.TOPLAM_FIYAT : '-'}
                        </TableCell>
                      </TableRow>
                    ))}
                    <TableCell
                      align="center"
                      sx={{ border: 'none' }}
                    ></TableCell>
                    <TableCell align="left" sx={{ border: 'none' }}></TableCell>
                    <TableCell
                      align="center"
                      sx={{ border: 'none' }}
                    ></TableCell>
                    <TableCell align="left" sx={{ border: 'none' }}></TableCell>
                    <TableCell
                      align="center"
                      sx={{ fontWeight: 'bold', border: 'none' }}
                    >
                      {'Toplam'}
                    </TableCell>
                    <TableCell align="center" sx={{ border: 'none' }}>
                      {materialCostData[0]?.TOPLAM
                        ? materialCostData[0]?.TOPLAM
                        : '0'}
                    </TableCell>
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <IconButton
            sx={{ color: '#FF9800' }}
            onClick={() => {
              setMaterialCostPopUp(false);
            }}
            aria-label="close"
            component="span"
            variant="contained"
          >
            <CloseIcon />
          </IconButton>
        </DialogActions>
      </Dialog>
      <Dialog
        open={actionReasonSavePopUp}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="md"
        fullWidth
      >
        <DialogContent>
          <Grid container spacing={4}>
            <Grid item xs={12} md={12}>
              <Autocomplete
                id="combo-box-demo"
                options={changeReasonData}
                disabled={
                  ![1, 2, 6].includes(Role[0]?.ROLE_ID) ||
                    invoiceData[0].AronStatus === 5
                    ? true
                    : false
                }
                getOptionLabel={(i) => i.Dsc}
                value={changeReasonList || null}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    InputProps={{
                      ...params.InputProps,
                      style: { fontSize: '12px' }
                    }}
                    InputLabelProps={{
                      style: { fontSize: '11px', color: '#757575' }
                    }}
                    size="small"
                    label="Değişim Nedeni"
                    sx={{
                      '& .MuiOutlinedInput-root': { borderRadius: '12px' }
                    }}
                  />
                )}
                renderOption={(props, option) => (
                  <li {...props}>
                    <Typography variant="body2" style={{ fontSize: '12px' }}>
                      {option.Dsc}
                    </Typography>
                  </li>
                )}
                onChange={(event, val) => {
                  changeReason(val);
                }}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <Autocomplete
                id="combo-box-demo"
                options={upChangeData}
                getOptionLabel={(i) => i.ACIKLAMA}
                disabled={
                  ![1, 2, 6].includes(Role[0]?.ROLE_ID) ||
                    invoiceData[0].AronStatus === 5
                    ? true
                    : false
                }
                value={upChangeReason || null}
                size="small"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    InputProps={{
                      ...params.InputProps,
                      style: { fontSize: '12px' }
                    }}
                    InputLabelProps={{
                      style: { fontSize: '11px', color: '#757575' }
                    }}
                    label="Detay"
                    size="small"
                    sx={{
                      '& .MuiOutlinedInput-root': { borderRadius: '12px' }
                    }}
                  />
                )}
                renderOption={(props, option) => (
                  <li {...props}>
                    <Typography variant="body2" style={{ fontSize: '12px' }}>
                      {option.ACIKLAMA}
                    </Typography>
                  </li>
                )}
                onChange={(event, val) => {
                  changeUpReason(val);
                }}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              {showAlert && (
                <Grid item xs={12} md={12}>
                  <Alert severity="warning">
                    Ürün üzerinde tanımlı ve aktif hasar hizmet kodu aktif
                    değil.
                  </Alert>
                </Grid>
              )}
            </Grid>
            <Grid item xs={12} md={12}>
              <Box sx={{ '& > :not(style)': { m: 1 } }} height={150}>
                <Tooltip title="Değişim Nedeni Açıklama Giriniz...">
                  <TextField
                    multiline
                    rows={5}
                    label="Değişim Nedeni Açıklama Giriniz...(En az 10 harf.)"
                    fullWidth
                    value={exhanchangeEditNote}
                    onChange={(e) => setExhanchangeEditNote(e.target.value)}
                    inputProps={{
                      style: { fontSize: '12px' }
                    }}
                    InputLabelProps={{
                      style: { fontSize: '11px', color: '#757575' }
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': { borderRadius: '12px' }
                    }}
                  />
                </Tooltip>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={() => {
              handleExchangeReasonSave();
            }}
            component="span"
            sx={{ color: '#FF9800', backgroundColor: '#424242' }}
          >
            {'Kaydet'}
          </Button>
          <IconButton
            sx={{ color: '#FF9800' }}
            onClick={() => {
              setActionReasonSavePopUp(false);
            }}
            aria-label="close"
            component="span"
            variant="contained"
          >
            <CloseIcon />
          </IconButton>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ExchangeInformation;
